import { Box } from "@mui/system";
import React, { useState } from "react";
import { images } from "../../Images/Svg";
import style from "./UploadedInvoices.module.css";
import { useNavigate } from "react-router";
import PdfOpener from "../../CommonComponents/Modal/PdfOpener";

const { backArrow, AodbeIcon, preview } = images;

// remove statusDummyData after getting api
const statusDummyData = [
  { id: 1, status: "reject" },
  { id: 2, status: "reject" },
  { id: 3, status: "pending" },
  { id: 4, status: "approve" },
];

const UploadedInvoices = ({ backHandler = () => {}, caseId }) => {
  const [isDocumentOpen, setIsDocumentOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState(null);
  const [activeCardId, setActiveCardId] = useState("");

  const navigate = useNavigate();

  const previewHandler = (status, id) => {
    setIsDocumentOpen(true);
    setActiveStatus(status);
    setActiveCardId(id);
  };

  const uploadCardStyle = (status) => {
    if (status === "reject") {
      return style.reject;
    } else if (status === "approve") {
      return style.approve;
    } else if (status === "pending") {
      return style.pending;
    }
  };

  const headerBackgroundColor = (status) => {
    if (status === "reject") {
      return style.rejectBackground;
    } else if (status === "approve") {
      return style.approveBackground;
    } else if (status === "pending") {
      return style.pendingBackground;
    }
  };

  const activeBgColor = (status) => {
    if (activeStatus === status && isDocumentOpen) {
      if (status === "reject") {
        return style.rejectActiveBackground;
      } else if (status === "approve") {
        return style.approveActiveBackground;
      } else if (status === "pending") {
        return style.pendingActiveBackground;
      }
    }
    return "";
  };

  return (
    <Box sx={{ marginTop: "20px", marginLeft: "25px" }}>
      <div className={style["uploaded_Invoice-header"]}>
        <img
          src={backArrow}
          alt="backArrow"
          style={{ cursor: "pointer", marginLeft: "-8px" }}
          onClick={backHandler}
        />
        <p>{`Case Number ${caseId}`}</p>
      </div>
      <h2 className={style["heading-uploaded"]}>Uploaded Invoices</h2>
      <div className={style["upload-Main-container"]}>
        {statusDummyData.map((item) => (
          <>
            <div className={uploadCardStyle(item.status)}>
              <h3 className={headerBackgroundColor(item.status)}>
                Approved on 01/03/2023
              </h3>
              <div
                className={`${style["docs_style"]}  ${
                  activeCardId === item.id ? activeBgColor(item.status) : ""
                } `}
              >
                <img
                  src={AodbeIcon}
                  alt="AodbeIcon"
                  style={{
                    filter:
                      isDocumentOpen && activeCardId === item.id
                        ? "brightness(0) invert(1)"
                        : "none",
                  }}
                />
                <div className={style["doc-name"]}>
                  <p>Invoiceabc12namcmksd1.pdf</p>
                  <p>2.4kb</p>
                </div>
                <img
                  src={preview}
                  alt="previewIcon"
                  style={{
                    cursor: "pointer",
                    boxShadow: "0 0 10px 2px rgba(0, 0, 0, 0.5)",
                    borderRadius: "50px",
                  }}
                  onClick={() => previewHandler(item.status, item.id)}
                />
              </div>
            </div>
          </>
        ))}
      </div>
      {activeStatus && isDocumentOpen && <PdfOpener />}
    </Box>
  );
};

export default UploadedInvoices;
